import styles from './NavigationBar.module.css';


const NavigationBar = ({activeMenu, setActiveMenu, isAdmin, setIsHotModalShown}) => {
  	return (
		<div className={styles.tabBarglobal}>
			<div className={`${styles.div} ${activeMenu === 'home' ? styles.active : ''}`} onClick={() => setActiveMenu('home')}>
				<div className={styles.content}>
					<div className={styles.frame}>
							<img className={`${styles.iconstarOutlined} ${activeMenu === 'home' ? styles.activeIcon : ''}`}
								alt="" src={activeMenu === 'home' ? "images/home_filled.svg" : "images/home_outlined.svg"} />
					</div>
					<div className={styles.div1}>홈</div>
				</div>
			</div>
			<div className={`${styles.div} ${activeMenu === 'search' ? styles.active : ''}`} onClick={() => setActiveMenu('search')}>
				<div className={styles.content}>
					<div className={styles.frame}>
							<img className={`${styles.iconstarOutlined} ${activeMenu === 'search' ? styles.activeIcon : ''}`} alt="" src="images/search.svg" />
					</div>
					<div className={styles.div1}>핫플찾기</div>
				</div>
			</div>
			<div className={styles.div} onClick={() => setIsHotModalShown(true)}>
				<div className={styles.rectangleParent}>
					<div className={styles.frameChild} />
					<img className={styles.iconfire} alt="" src="images/fire.svg" />
				</div>
			</div>
			<div className={`${styles.div} ${activeMenu === 'shop' ? styles.active : ''}`} onClick={() => setActiveMenu('shop')}>
				<div className={styles.content}>
					<div className={styles.frame}>
							<img className={`${styles.iconfire1} ${activeMenu === 'shop' ? styles.activeIcon : ''}`} alt="" src="images/fire.svg" />
					</div>
					<div className={styles.div1}>핫플샵</div>
				</div>
			</div>
			<div className={`${styles.div} ${activeMenu === 'my' ? styles.active : ''}`} onClick={() => setActiveMenu('my')}>
				<div className={styles.content}>
					<div className={styles.frame}>
							<img className={`${styles.iconlikeOutlined} ${activeMenu === 'my' ? styles.activeIcon : ''}`} alt=""
								src={activeMenu === 'my' ? "images/like_active.svg" : "images/like_outlined.svg"} />
					</div>
					<div className={styles.div1}>내 핫플</div>
				</div>
			</div>
		</div>
	);
};

export default NavigationBar;
